export enum RelationEntityType {
  PROJECT = 'PROJECT',
  ORDER = 'ORDER',
  OFFER = 'OFFER',
  MISSION = 'MISSION',
  BILL = 'BILL',
}
